import { render, staticRenderFns } from "./RemunerationsDocsTable.vue?vue&type=template&id=6c0e42b1&scoped=true"
import script from "./RemunerationsDocsTable.vue?vue&type=script&lang=js"
export * from "./RemunerationsDocsTable.vue?vue&type=script&lang=js"
import style0 from "./RemunerationsDocsTable.vue?vue&type=style&index=0&id=6c0e42b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0e42b1",
  null
  
)

export default component.exports